import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import "../../../i18n";
import './style.css';

import EmailIcon from '@mui/icons-material/Email';
import { Alert, Dialog, DialogContent, InputAdornment } from "@mui/material";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from "axios";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { logEvent } from "../../../analytics";
import HeartIcon from '../../../assets/icons/SVGIcons/Heart 16-16 1.svg';
import GMZbg from '../../../assets/images/SigninPageImages/BG_for_Login_12-10-2024.webp';
import GamizignLogo from '../../../assets/images/SigninPageImages/Gamizign-logo.png';
import upgradIcon from '../../../assets/icons/SVGIcons/AIGenerateIcon.svg';
import LanguageSwitcher from "../../GlobalComponents/LanguagePicker";
import MetaTags from "../../GlobalComponents/MetaData";
import GoldCourse from "../../GlobalComponents/AiCourse/GoldCourse";



const SignIn = ({ mode, setMode }) => {
  const logoRef = useRef(null);
  const [showLoginFields, setShowLoginFields] = useState(false);
  const { t, i18n } = useTranslation();

  const [IncEmail, setIncEmail] = useState('')
  const navigate = useNavigate();
  const [state, setState] = useState({
    showPassword: false,
    password: '',
    error: '',
    isLoading: false,
  });
  // Navigate payment page for repay
  const [detalsData, setdetalsData] = useState(null)
  const repay = () => {
    navigate(`/upgradeplan`, { state: detalsData });
  }
  // ReActivate Account handle
  const ReActivateAccount = async() => {
    setProgrees(true);
    try{
      const respons = await axios.post(`${process.env.REACT_APP_ENDPOINT}/instructors/${detalsData.user.instructor_id}/reactivate`);
      const authData = {target:{email:{value:detalsData.authData.username}, password:{value:detalsData.authData.password}}}
      await handleSubmit(authData);
      setErrorMessage(t('Signin.ReactiveSuccess'));
    }catch (error){
      console.log(error);
      setErrorMessage(t('Signin.ErrorReactive'));
    }finally{setProgrees(false);}
  }
  // Login handle
  const currentDomain = window.location.hostname;
  const handleSubmit = async (event) => {
    logEvent('signin', 'login clicked', 'Login by enetering email and password');
    if(event.preventDefault) event.preventDefault();
    setState((prevState) => ({ ...prevState, error: '', isLoading: true }));
    handleLoginResult(true);
    const authData = {
      username: event.target.email.value,
      password: event.target.password.value
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_ENDPOINT}/token`, authData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        }
      });
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
      const responseData = response.data;      
      localStorage.setItem("user_type", responseData.user_type);
      Cookies.set("token", `Bearer ${responseData.access_token}`, {
        expires: 3,
        secure: true,
        sameSite: "Lax",
        domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
      });
      if (responseData.user.is_deactivated) {
        setErrorMessage(t('Signin.AccountDeactivatedMsg'));
        setPymentError(true);
        setdetalsData({...responseData, authData});
        setState((prevState) => ({ ...prevState, error: t('Signin.AccountDeactivated'), isLoading: false }));
        return;
      }

      if (responseData.user_type === "Instructor") {
        const getCoursesCount = await axios.get(`${process.env.REACT_APP_ENDPOINT}/instructors/{instructor_id}/account/?email=${authData.username}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${responseData.access_token}`
          }
        });        
        const { firstName, lastName, email, instructor_id, organization_id, emailActivated, accountActive, admin_id, single_count, journey_count, questions_count, student_count, profilePicture } = getCoursesCount.data;
        const LearnerTab = admin_id ? 'hide' : 'show';
        const Onboarding = accountActive ? 2 : 0;
        Cookies.set("instructor_id", instructor_id);
        localStorage.setItem("profilePicture", profilePicture);
        Cookies.set("admin_id", admin_id);
        localStorage.setItem("name", firstName);
        localStorage.setItem("lastname", lastName);
        localStorage.setItem("email", email);
        Cookies.set("organization", organization_id);
        localStorage.setItem("LearnersList", LearnerTab);
        localStorage.setItem("accountActive", single_count + journey_count);
        Cookies.set("plan", responseData.license.license_type);
        localStorage.setItem("coursesLength", single_count + journey_count);
        localStorage.setItem("singleCourses", single_count);
        localStorage.setItem("journeyCourses", journey_count);
        localStorage.setItem("qestionListsLength", questions_count);
        localStorage.setItem("studentsLength", student_count);
        localStorage.setItem("emailActive", emailActivated ? emailActivated : "");
        Cookies.set("activatedTrial", responseData.license.activatedTrial ? responseData.license.activatedTrial : "");
        sessionStorage.setItem("tab", responseData.license.license_type === '3' ? 11 : 4);
        if (LearnerTab === 'show' && Onboarding === 0) {
          sessionStorage.setItem("tab", 1);
          window.location.href = '/Dashboard/CreateCourse'
        } else if (LearnerTab === 'hide') {
          if (questions_count < 1) {
            window.location.href = `/Dashboard/questionList`;
            sessionStorage.setItem("tab", 2);
          } else if ((single_count+journey_count) < 1) {
            window.location.href = `/Dashboard/CreateCourse`;
            sessionStorage.setItem("tab", 1);

          } else {
            window.location.href = `/Dashboard`;
            sessionStorage.setItem("tab", 11);
          }
        }
      } else {
        Cookies.set("admin_id", responseData.user.admin_id);
        localStorage.setItem("adminName", responseData.user.first_name);
        localStorage.setItem("adminEmail", responseData.user.email);
        Cookies.set("organization", responseData.user.organization_id);
        Cookies.set("plan", responseData.license.license_type);
        window.location.href = `/Admin`;
      }

      handleLoginResult(true);
      setState((prevState) => ({ ...prevState, error: '', isLoading: false }));
    } catch (error) {
      let errorMessage = '';
      if (error.response.status === 402) {
        const detail = error.response.data.detail;
        Cookies.set("token", `Bearer ${detail.access_token}`, {
          expires: 3,
          secure: true,
          sameSite: "Lax",
          domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
        });

        localStorage.setItem("email", authData.username);
        localStorage.setItem('updatesPlan', detail.license_type);
        localStorage.setItem('updatesBill_type', detail.bill_type);
        setdetalsData(detail);
        if (detail.new_user) {
          setErrorMessage(t('Signin.LicenseExpired'));
          setPymentError(true);
          setTimeout(() => {
            navigate('/payment', {
              state: {
                license_type: detail.license_type,
                bill_type: detail.bill_type,
                organization_id: detail.organization_id
              }
            });
          }, 2000);
          // navigate('/payment', { state: { license_type: detail.license_type, bill_type: detail.bill_type, organization_id: detail.organization_id } });
        } else {
          setErrorMessage(t('Signin.LicenseExpired1'));
          setPymentError(true);
        }

      } else {
        errorMessage = t('Signin.InvalidLogin');
      }
      setState((prevState) => ({ ...prevState, error: errorMessage, isLoading: false }));
      handleLoginResult(false);
      console.error('Error during login:', error);
    }
  };

  const togglePasswordVisibility = () => {
    setState((prevState) => ({ ...prevState, showPassword: !prevState.showPassword }));
  };

  const handleLoginResult = (isCorrectLogin) => {
    const inputs = document.querySelectorAll("input");

    inputs.forEach((input) => {
      input.readOnly = isCorrectLogin;
    });
  }
  // login  wih google
  const handleGoogleLogin = async (credentialResponse) => {
    logEvent('signin', 'login clicked', 'Login by google');
    var jwtToken = credentialResponse.credential.toString();
    setState((prevState) => ({ ...prevState, error: '', isLoading: true }));
    fetch(`${process.env.REACT_APP_ENDPOINT}/handle_token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: jwtToken,
      }),
    })
      .then(response => response.json())
      .then(async responseData => {
        if (responseData.detail !== 'License expired') {
          // if (responseData.is_deactivated) {
          //   setErrorMessage(t('Signin.AccountDeactivatedMsg'));
          //   setPymentError(true);
          //   setdetalsData(responseData);
          //   setState((prevState) => ({ ...prevState, error: t('Signin.AccountDeactivated'), isLoading: false }));
          //   return;
          // }
          const getCoursesCount = await axios.get(`${process.env.REACT_APP_ENDPOINT}/instructors/{instructor_id}/account/?email=${responseData.email}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${responseData.access_token}`
            }
          });
          const { firstName, lastName, email, instructor_id, organization_id, emailActivated, accountActive, admin_id, single_count, journey_count, questions_count, student_count, profilePicture } = getCoursesCount.data;
          // if (emailActivated) {
          const LearnerTab = admin_id ? 'hide' : 'show';
          const Onboarding = accountActive ? 2 : 0;
          Cookies.set("instructor_id", instructor_id);
          localStorage.setItem("profilePicture", profilePicture);
          Cookies.set("admin_id", admin_id);
          localStorage.setItem("name", firstName);
          localStorage.setItem("lastname", lastName);
          localStorage.setItem("email", email);
          Cookies.set("organization", organization_id);
          localStorage.setItem("user_type", responseData.user_type);
          Cookies.set("token", `Bearer ${responseData.access_token}`, {
            expires: 3,
            secure: true,
            sameSite: "Lax",
            domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
          });

          localStorage.setItem("LearnersList", LearnerTab);
          localStorage.setItem("accountActive", single_count + journey_count);
          Cookies.set("plan", responseData.license.license_type);
          localStorage.setItem("coursesLength", single_count + journey_count);
          localStorage.setItem("singleCourses", single_count);
          localStorage.setItem("journeyCourses", journey_count);
          localStorage.setItem("qestionListsLength", questions_count);
          localStorage.setItem("studentsLength", student_count);
          localStorage.setItem("emailActive", emailActivated ? emailActivated : "");
          Cookies.set("activatedTrial", responseData.license.activatedTrial ? responseData.license.activatedTrial : "");
          sessionStorage.setItem("tab", responseData.license.license_type === '3' ? 11 : 4);
          if (LearnerTab === 'show' && Onboarding == 0) {
            sessionStorage.setItem("tab", 1);
            window.location.href = '/Dashboard/CreateCourse'
          } else if (LearnerTab === 'hide') {
            if (questions_count < 1) {
              window.location.href = `/Dashboard/questionList`;
              sessionStorage.setItem("tab", 2);
            } else if ((single_count + journey_count) < 1) {
              window.location.href = `/Dashboard/CreateCourse`;
              sessionStorage.setItem("tab", 1);

            } else {
              window.location.href = `/Dashboard`;
              sessionStorage.setItem("tab", 11);
            }
          }
          setState((prevState) => ({ ...prevState, error: '', isLoading: false }));
        } else {
          handleLoginResult(false);
          setState((prevState) => ({ ...prevState, isLoading: false }));
          if (responseData.admin_id) {
            setErrorMessage(t('Signin.LicenseExpiredAdmin'));
            setPymentError(true);
          } else {
            setErrorMessage(t('Signin.LicenseExpired1'));
            setPymentError(true);
          }
        }
      })
      .catch(error => {
        if (error.response.status === 402) {
          const detail = error.response.data.detail;
          Cookies.set("token", `Bearer ${detail.access_token}`, {
            expires: 3,
            secure: true,
            sameSite: "Lax",
            domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
          });

          localStorage.setItem('updatesPlan', detail.license_type);
          localStorage.setItem('updatesBill_type', detail.bill_type);
          setdetalsData(detail);
          if (detail.new_user) {
            setErrorMessage(t('Signin.LicenseExpired'));
            setPymentError(true);
            setTimeout(() => {
              navigate('/payment', {
                state: {
                  license_type: detail.license_type,
                  bill_type: detail.bill_type,
                  organization_id: detail.organization_id
                }
              });
            }, 2000);
            // navigate('/payment', { state: { license_type: detail.license_type, bill_type: detail.bill_type, organization_id: detail.organization_id } });
          } else {
            setErrorMessage(t('Signin.LicenseExpired1'));
            setPymentError(true);
          }

        } else {
          const errorMessage = t('Signin.ErrorGoogleLogging');
          setState((prevState) => ({ ...prevState, error: errorMessage, isLoading: false }));
          handleLoginResult(false);
          console.error('Error decoding JWT on the server:', error);
        }
      });
  }
  const [pymentError, setPymentError] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState('');
  // Resend verification email
  const [ActiveEmail, setActiveEmail] = useState({});
  const [Progrees, setProgrees] = useState(false);
  const resendVarification = async () => {
    setProgrees(true);
    const currentTime = new Date().getTime();
    const lastRequestTime = sessionStorage.getItem('lastRequestTime');
    if (lastRequestTime && currentTime - lastRequestTime < 3600000) {
      setErrorMessage('You requested activation email in the last hour, check you Mail spam folder or try after one hour.');
      setProgrees(false);
      return;
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_ENDPOINT}/send-activation-email`, ActiveEmail);
      if (response.status === 200) {
        setErrorMessage('Email has been resent');
        sessionStorage.setItem('lastRequestTime', currentTime);

      }
    } catch (error) {
      setErrorMessage('An error occured while resending email try again later.');
      setProgrees(false);

    } finally {
      setProgrees(false);
    }

  };
  const closeDialog = () => {
    setPymentError(false);
    handleLoginResult(false);
  }
  useEffect(() => {
    const currentLogo = logoRef.current; // Store the current value of the ref
    if (currentLogo) {
      // Listen for the end of the logo animation
      const handleAnimationEnd = () => {
        // Show login fields after logo animation completes
        setShowLoginFields(true);
      };

      // Add event listener to the logo animation
      currentLogo.addEventListener('animationend', handleAnimationEnd);

      // Cleanup function to remove event listener from the stored currentLogo element
      return () => {
        currentLogo.removeEventListener('animationend', handleAnimationEnd);
      };
    }
  }, [i18n]);
  const [errorGettingAuth, setErrorGettingAuth] = useState('');
  const [goldCourse, setGoldCourse] = useState(true);
  const handleTryGold = async () => {
    setErrorGettingAuth('');
    try {
      setState((prevState) => ({ ...prevState, isLoading: true }));
      const GetToken = await axios.post(`${process.env.REACT_APP_ENDPOINT}/token`, 
        {
          "username": "1",
          "password": "123"
        }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
      });
      const token = GetToken.data.access_token;
      Cookies.set("token", `Bearer ${token}`, {
        expires: 3,
        secure: true,
        sameSite: "Lax",
        domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
      });
      // navigate('/gamizigngold');
      window.location.href='/gamizigngold';
    } catch (error) {
      console.error('error getting token',error);
      setErrorGettingAuth('Someting wend wrong try again.')
    }finally{setState((prevState) => ({ ...prevState, isLoading: false }));}
  }

  return (
    // <Paper>
    <div style={{ background: mode === 'light' ? '#F6F8FC' : 'white', backgroundImage: `url(${GMZbg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      <MetaTags title={t("Signin.WelcomeGamizign")} description='Welcome to Gamizign page--' />
      <div className={`z-10 absolute top-0 ${i18n.language === 'en' ? 'right-1 sm:right-3' : 'left-1 sm:left-3'}  p-2`}>
        {/* Language Selector */}
        <LanguageSwitcher />
      </div>
      <Dialog open={pymentError} onClose={closeDialog} disabled={Progrees}>
        <DialogContent>
          {Progrees && (
            <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-75 z-50">
              <CircularProgress className="text-blue-800" />
            </div>
          )}
          <Alert severity={ErrorMessage===t('Signin.ReactiveSuccess')?'success':"error"}>{ErrorMessage}</Alert>
        </DialogContent>
        {ErrorMessage === t('Signin.LicenseExpired1') ?
              <div className='flex justify-center'>
                <Button onClick={repay} color="primary">
                  {/* <Link to={`/upgradeplan?email=${ActiveEmail.email}`}> */}
                  <p>{t('Signin.Upgrade')}</p>
                  {/* </Link> */}
                </Button>
                <Button onClick={closeDialog} color="primary">
                  <p>{t('Signin.Okay')}</p>
                </Button>
              </div> : <div className='flex justify-center'>
                {ErrorMessage === t('Signin.AccountDeactivatedMsg')&&
                <Button onClick={ReActivateAccount}>
                  {t('Signin.ReActive')}
                  </Button>}
                <Button onClick={closeDialog} color="primary">
                  <p>{ErrorMessage === t('Signin.AccountDeactivatedMsg')?t('Signin.Cancel'):t('Signin.Okay')}</p>
                </Button>
              </div>}
      </Dialog>
        <div className="flex justify-center items-center" style={{ height: 'fit-content', }}>
          {/* <div className="flex-1">
            <div onClick={handleTryGold} className="border rounded shadow flex justify-center cursor-pointer hover:bg-blue-200">
              <div className="">
                <span className="flex justify-center"><img className="" src={upgradIcon} alt="upgradIcon" /></span>
              <span className="font-bold text-3xl text-white">Gamizign Gold</span>
              <p className="my-2 bg-white font-bold text-red-600">{errorGettingAuth}</p>
              </div>
            </div>
          </div> */}
          <div className="flex-1"></div>
          <div className="flex-none SignIn text-center justify-center px-0 py-0" >
            <div className="flex justify-center"><img className="logo" ref={logoRef} src={GamizignLogo} width={200} alt="LogoImage" /></div>
            {/* {goldCourse?<div>
              <GoldCourse />
              <button onClick={()=>setGoldCourse(false)}>Already a user?</button>
              </div>
              : */}
            <div className={`login-fields-container ${showLoginFields ? 'login-fields' : ''}`}>
              <div className="drop-shadow-xl rounded-b-3xl bg-transparent relative">
                {state.isLoading && (
                  <div className="absolute inset-0 py-40 flex justify-center items-center bg-transparent bg-opacity-75 z-50">
                    <CircularProgress className="text-blue-800" />
                  </div>
                )}
                <form className="container p-3 px-5" action="post" onSubmit={handleSubmit}>
                  <TextField
                    margin="dense"
                    label={t("Signin.Email")}
                    name="email"
                    type="email"
                    required
                    placeholder="mohd@example.com"
                    fullWidth
                    sx={{
                      marginTop: '20px',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          border: mode === 'light' ? 'none' : '',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #4183d9',
                        },
                      },
                      '& input': {
                        textAlign: i18n.language === 'ar' ? 'right' : 'left',
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon style={{ color: mode === 'light' ? '#4183d9' : '' }} />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: "10px",
                        color: mode === 'light' ? '#4183d9' : '', background: mode === 'light' ? 'white' : '',
                        fontSize: '20px',
                      }
                    }}
                  />
                  <TextField
                    margin="dense"
                    label={t("Signin.Password")}
                    name="password"
                    type={state.showPassword ? 'text' : 'password'}
                    required
                    placeholder={t("Signin.PasswordPlaceholder")}
                    fullWidth
                    className=""
                    sx={{
                      marginTop: '20px',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          border: mode === 'light' ? 'none' : '',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #4183d9',
                        },
                      },
                      '& input': {
                        textAlign: i18n.language === 'ar' ? 'right' : 'left',
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <span onClick={togglePasswordVisibility} className="cursor-pointer">{state.showPassword ? <FaEye style={{ color: mode === 'light' ? '#4183d9' : '' }} size={24} /> : <FaEyeSlash style={{ color: mode === 'light' ? '#4183d9' : '' }} size={24} />}</span>
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: "10px",
                        fontSize: '20px',
                        color: mode === 'light' ? '#4183d9' : '', background: mode === 'light' ? 'white' : '',
                      }
                    }}
                  />
                  {state.error && <p style={{ color: 'red' }}>{state.error}</p>}
                  <button className="py-1 flex justify-start font-bold ms-2 1mt-2" style={{ color: '#4183d9' }} type="button"><Link to='/reset-password'>{t("Signin.ForgotPassword")}</Link></button>
                  <div className="flex justify-center items-center gap-1 py-1 mb-5"><img src={HeartIcon} alt="HeartIcon" /><p>{t("Signin.Kindly")}</p></div>
                  <button className="relative overflow-hidden group transition-all duration-500 btn GameOn hover:scale-110 text-2xl py-2 w-full " type="submit" disabled={state.isLoading}>
                    <span className={`absolute inset-0 bg-[#F6C1C1] ${i18n.language==='ar'?'translate-x-full':'-translate-x-full'}  group-hover:translate-x-0 transition-transform duration-500`}></span>
                    <label className="relative"><b>{t('Signin.signin')}</b></label>
                  </button>

                  <GoogleOAuthProvider clientId="1071328084227-056krbch512vrpup6fgevl6j8i55g7ic.apps.googleusercontent.com">
                    <GoogleLogin
                      onSuccess={handleGoogleLogin}
                      shape="circle"
                      type="standard"
                      logo_alignment="left"
                      text="continue_with"
                      theme="filled_blue"
                      size="large"
                      locale={i18n.language === "ar" ? "ar" : "en"}
                      useOneTap
                      disabled={state.isLoading} // Disable the button when loading
                    />
                  </GoogleOAuthProvider>
                  <button onClick={() => {navigate('/signup') }} className="btn transition-transform transform  hover:scale-110 py-2 w-full" type="button">
                    {t("Signin.Create a new account")}
                  </button>
                  <button className="transition-transform transform hover:scale-110" type="button" onClick={() => {navigate('/goldCourse') }}>{t("Signin.TryGamizignGold")}</button>
                </form>
              </div>
              <p className="mt-4"><Link className="" target="_blank" to="https://gamizign.com/privacy-policy/">{t("Signin.PrivacyPolicyTerms")}</Link></p>
              <p className="mt-4"><Link className="" target="_blank" to="https://gamizign.com/refund-policy/">{t("Signin.RefundCancellation")}</Link></p>
            </div>
            {/* } */}

          </div>
          <div className="flex-1"></div>
        </div>

    </div>
    // </Paper>
  );

};
export default SignIn;
